import { render, staticRenderFns } from "./tariff-fee-trans.vue?vue&type=template&id=9022f86a"
import script from "./tariff-fee-trans.vue?vue&type=script&lang=js"
export * from "./tariff-fee-trans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports